
import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { TaxInfoCacheViewModel } from './taxInfoCacheViewModel';

export class TaxInfoCacheContainer extends MasterDataContainer<TaxInfoCacheViewModel> {
    constructor(models: Array<TaxInfoCacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
